/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Admin_Dashboard_Members_Leaving_This_MonthInputs */

const en_admin_dashboard_members_leaving_this_month = /** @type {(inputs: Admin_Dashboard_Members_Leaving_This_MonthInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en", i?.count, {});
	if (countPlural == "one") return /** @type {LocalizedString} */ (`member leaving this month`);
	if (countPlural == "other") return /** @type {LocalizedString} */ (`members leaving this month`);
	return /** @type {LocalizedString} */ ("admin.dashboard.members_leaving_this_month");
};

const de_admin_dashboard_members_leaving_this_month = /** @type {(inputs: Admin_Dashboard_Members_Leaving_This_MonthInputs) => LocalizedString} */ (i) => {
	const countPlural = registry.plural("de", i?.count, {});return /** @type {LocalizedString} */ (`Mitglieder verlassen diesen Monat den Space`)
};

const es_admin_dashboard_members_leaving_this_month = /** @type {(inputs: Admin_Dashboard_Members_Leaving_This_MonthInputs) => LocalizedString} */ (i) => {
	const countPlural = registry.plural("es", i?.count, {});return /** @type {LocalizedString} */ (`miembros se van este mes`)
};

const fr_admin_dashboard_members_leaving_this_month = /** @type {(inputs: Admin_Dashboard_Members_Leaving_This_MonthInputs) => LocalizedString} */ (i) => {
	const countPlural = registry.plural("fr", i?.count, {});return /** @type {LocalizedString} */ (`membres quittent ce mois-ci`)
};

const nl_admin_dashboard_members_leaving_this_month = /** @type {(inputs: Admin_Dashboard_Members_Leaving_This_MonthInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("nl", i?.count, {});
	if (countPlural == "one") return /** @type {LocalizedString} */ (`lid vertrekt deze maand`);
	if (countPlural == "other") return /** @type {LocalizedString} */ (`leden vertrekken deze maand`);
	return /** @type {LocalizedString} */ ("admin.dashboard.members_leaving_this_month");
};

const it_admin_dashboard_members_leaving_this_month = /** @type {(inputs: Admin_Dashboard_Members_Leaving_This_MonthInputs) => LocalizedString} */ (i) => {
	const countPlural = registry.plural("it", i?.count, {});return /** @type {LocalizedString} */ (`membri in uscita questo mese`)
};

const pt_br2_admin_dashboard_members_leaving_this_month = /** @type {(inputs: Admin_Dashboard_Members_Leaving_This_MonthInputs) => LocalizedString} */ (i) => {
	const countPlural = registry.plural("pt-BR", i?.count, {});return /** @type {LocalizedString} */ (`membros saindo este mês`)
};

const pl_admin_dashboard_members_leaving_this_month = /** @type {(inputs: Admin_Dashboard_Members_Leaving_This_MonthInputs) => LocalizedString} */ (i) => {
	const countPlural = registry.plural("pl", i?.count, {});return /** @type {LocalizedString} */ (`członków odchodzi w tym miesiącu`)
};

const hu_admin_dashboard_members_leaving_this_month = /** @type {(inputs: Admin_Dashboard_Members_Leaving_This_MonthInputs) => LocalizedString} */ (i) => {
	const countPlural = registry.plural("hu", i?.count, {});return /** @type {LocalizedString} */ (`tag távozik ebben a hónapban`)
};

/** @type {(inputs: Admin_Dashboard_Members_Leaving_This_MonthInputs) => LocalizedString} */
const ro_admin_dashboard_members_leaving_this_month = en_admin_dashboard_members_leaving_this_month;

/**
* | countPlural | output |
* | --- | --- |
* | "one" | "member leaving this month" |
* | "other" | "members leaving this month" |
*
* @param {Admin_Dashboard_Members_Leaving_This_MonthInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_members_leaving_this_month = /** @type {((inputs: Admin_Dashboard_Members_Leaving_This_MonthInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_Members_Leaving_This_MonthInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_members_leaving_this_month(inputs)
	if (locale === "de") return de_admin_dashboard_members_leaving_this_month(inputs)
	if (locale === "es") return es_admin_dashboard_members_leaving_this_month(inputs)
	if (locale === "fr") return fr_admin_dashboard_members_leaving_this_month(inputs)
	if (locale === "nl") return nl_admin_dashboard_members_leaving_this_month(inputs)
	if (locale === "it") return it_admin_dashboard_members_leaving_this_month(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_members_leaving_this_month(inputs)
	if (locale === "pl") return pl_admin_dashboard_members_leaving_this_month(inputs)
	if (locale === "hu") return hu_admin_dashboard_members_leaving_this_month(inputs)
	return ro_admin_dashboard_members_leaving_this_month(inputs)
});
export { admin_dashboard_members_leaving_this_month as "admin.dashboard.members_leaving_this_month" }